import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useTl, useApiService } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { ColorDetailPage } from "..";
import { useApiEffect } from "nsitools-react";
import { ColorApi } from "../../../../api";
import { useGlobalData } from "../../../../contexts";

export interface IColorItemPageProps {}

export const ColorItemPage: React.FunctionComponent<IColorItemPageProps> = (props) => {
  const { id, tab, state } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const { t } = useTl();
  const api = useApiService(ColorApi);
  const { currentLanguage } = useGlobalData();
  const [displayName, loading] = useApiEffect(() => api.getDisplayName(+id, currentLanguage.languageCode), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Colors), route: ERoutes.color },
        { text: +id > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsColor"
        onChange={(newTabId) => history.push(`${ERoutes.color}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.color} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<ColorDetailPage colorId={+id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
